export class SiteContactSiteViewModel {
  public id: string;
  public irgSiteId: string;
  public siteId: string;
  public siteName: string;
  public trialCode: string;
  public trialNickname: string;
  public trialOpportunityNumber: string;
  public trialId: string;
  public role: number;
  public roleName: string;
  public deleted: boolean;
  public blinded: boolean;

  constructor(init?: Partial<SiteContactSiteViewModel>) {
    if (init)
      Object.assign(this, init);
  }
}
